import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 10px 0;
  padding: 20px;
  height: fit-content;
`;

export const SvgContainer = styled.svg`
  width: 100%;
  /* width: 100%;
  max-width: 500px;
  margin: 10px 0;
  padding: 20px; */
`;
